<template>
    <v-combobox
        v-model="childData"
        :label="label"
        :rules="rules"
        :items="items"
        :filter="filter"
        item-text="name"
        clearable
    ></v-combobox>
</template>
<script>
import CommonDataService from "../services/CommonDataService";
import ComboBoxUtil from '../utils/ComboBoxUtil'
export default {
    name: "SalesmanCombo",
    props:{
        value:Object, //因為要跟父元件的v-model綁定，屬性名稱必須叫做value。
        label: String, //對應到Label
        rules: Array, //對應到Rule
    },
    data(){
        return {
            childData: this.value,
            items: [],
            nonceCount: 0
        }
    },
    created() {
        CommonDataService.findSalesmans().then((response) =>{
                this.items = response.list
                this.nonceCount = this.items.length 
            })
            .catch((e) => {
                console.log(e);
            });
    },
    watch:{
        value(val){
            //this.childData = this.getModel(val)
            this.childData = ComboBoxUtil.getComboBoxModel(val,this.items,{id:-1, name:''})
        },
        childData(val){
            //this.$emit('input', this.getModel(val))  
            this.$emit('input', ComboBoxUtil.getComboBoxModel(val,this.items,{id:-1, name:''}))  
        }
    },
    methods:{
        filter(val, queryText, itemText){
            //console.log('SalesmanCombo. filter, val =')
            //console.log(val)
            const hasValue = val => val != null ? val : '' //建立內部函式hasValue，把val用=>指到一個函式，利用三元判斷val的值。
            const text = hasValue(itemText) //呼叫內部函式
            const query = hasValue(queryText)
            return text.toString()
                .toLowerCase()
                .indexOf(query.toString().toLowerCase()) > -1
        }
    }
}
</script>
